// airsim add 2026.06.07
// 외부 사이트 링크 모음 (메뉴얼/가이드 등). 새 외부 사이트는 여기에 상수로 추가.
// 향후 블로그나 홈페이지 또는 유튜브 같은 것들을 서비스 내 사용할때 이곳 활용
// 메뉴얼: 그룹웨어프로 사용자 가이드(Oopy 발행 노션 사이트) — 검색은 Oopy 자체 검색(우상단 돋보기)을 iframe 안에서 활용
export const MANUAL_GUIDE_URL = "https://groupwarepro.oopy.io/";
